module.exports = __webpack_public_path__ + "static/media/hidratacion25k.9b0a4b83.webp";